import { createRender } from './types';

export const render = createRender((p) => (
	<div data-testid="test-message-inapp-implicit-pendo">
		Conquering {p.planet} is {p.status}
	</div>
));

export default render;
